module.exports = __webpack_public_path__ + "img/Heroku.0ad14187.png";